<template>
  <div class="table_side-create mb-12">
     <div class="table_side-content">
       <smsc-col>
         <smsc-col-item>
           <vs-input
             v-validate="'required'"
             name="first name"
             class="w-100 p-4"
             :class="{'is-danger': errors.has('first name')}"
             type="text"
             label="First Name"
             placeholder="First Name"
             v-model="payload.first_name"
           />
           <span class="text-danger text-xs  p-4">{{ errors.first('first name') }}</span>
          </smsc-col-item>
          <smsc-col-item>
            <vs-input
              v-validate="'required'"
              name="last name"
              class="w-100 p-4"
              :class="{'is-danger': errors.has('last name')}"
              type="text"
              label="Last Name"
              placeholder="Last Name"
              v-model="payload.last_name"
             />
             <span class="text-danger text-xs p-4">{{ errors.first('last name') }}</span>
           </smsc-col-item>
           <smsc-col-item>
             <vs-input
               v-validate="'required'"
               name="phone number"
               class="w-100 p-4"
               :class="{'is-danger': errors.has('phone number')}"
               type="number"
               label="Phone Number"
               placeholder="Phone Number"
               v-model="payload.phone_number"
             />
             <span class="text-danger text-xs p-4">{{ errors.first('phone number') }}</span>
           </smsc-col-item>
           <smsc-col-item>
             <vs-input
               v-validate="'required'"
               name="address"
               class="w-100 p-4"
               :class="{'is-danger': errors.has('address')}"
               type="text"
               label="Address"
               placeholder="Address"
               v-model="payload.address"
             />
             <span class="text-danger text-xs p-4">{{ errors.first('address') }}</span>
           </smsc-col-item>
       </smsc-col>
       <div class="buttons-container flex flex-wrap items-center justify-end pb-3 mr-3">
         <vs-button
           @click="addNewContact"
           class="mt-3"
         >Add Contact</vs-button>
       </div>
     </div>
  </div>
</template>

<script>
export default {
  name: "Create",
  data(){
    return {
      payload: {
        first_name: '',
        last_name: '',
        phone_number: '',
        address: '',
      }
    }
  },
  methods: {
  async addNewContact() {
     const valid = await this.$validator.validate()
     if (!valid) {
       return
     }
    this.$store.dispatch('recipient/AddRecipient', {...this.payload})
      .then(() => {
        this.ShowSuccessMessage({ title: 'Success', text: 'Contact Successfully Created' })
        this.$router.push({name: 'company_admin_contact'})
      })
      .catch(err => this.ShowErrorMessage({ title: 'Error', text: 'Something went wrong' }))
      .finally(() => this.$vs.loading.close())
   },
    // Notify
    ShowSuccessMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success',
        title,
        text
      })
    },
    ShowErrorMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        title,
        text
      })
    },
  }
}
</script>

<style scoped lang="scss">
 .table_side-create {
   background: white;
   .table_side-content {
     padding: 25px;
   }
 }
</style>
